const inbox = {
  statuses: {
    pending: "در انتظار بررسی",
    approved: "تأییدشده",
    posted: "منتشرشده",
    archived: "بایگانی‌شده",
  },
  original: {
    title: "پست اصلی",
    open: "باز کردن",
    openOriginal: "باز کردن پست اصلی",
    mediaOnly: "این پست تلگرام فقط رسانه دارد و توضیح متنی ندارد.",
    attachmentAlt: "پیوست پست تلگرام",
    summary: "خلاصه محتوای اصلی",
    characters_one: "{{formattedCount}} نویسه",
    characters_other: "{{formattedCount}} نویسه",
    mediaAttached: "رسانه پیوست شده",
  },
  preview: {
    title: "پیش‌نمایش تلگرام",
    empty: "پیام ویرایش‌شده تلگرام اینجا نمایش داده می‌شود.",
    label: "پیش‌نمایش",
    source: "منبع: @{{channel}}",
  },
  ai: {
    toolkit: "ابزارهای پردازش محتوا با هوش مصنوعی",
    generating: "در حال تولید",
    description: "این ابزارها با هوش مصنوعی سمت سرور کار می‌کنند و فقط برای ویرایش پست هنگام بررسی هستند.",
    draftReady: "پیش‌نویس هوش مصنوعی آماده است",
    suggestionDescription: "پیشنهاد «{{action}}» را پیش از اعمال بررسی کنید.",
    before: "قبل",
    after: "بعد",
    dismiss: "رد کردن",
    apply: "اعمال",
    actions: {
      rephrase: "بازنویسی",
      summarize: "خلاصه‌سازی",
      translate: "ترجمه",
      hashtags: "هشتگ‌ها",
    },
    tone: "لحن",
    language: "زبان",
    tones: {
      professional: "حرفه‌ای",
      casual: "خودمانی",
      viral: "جذاب و وایرال",
      news: "خبری و تحلیلی",
      bullets: "خلاصه فهرست‌وار",
    },
    languages: {
      english: "انگلیسی",
      spanish: "اسپانیایی",
      russian: "روسی",
      french: "فرانسوی",
      german: "آلمانی",
      chinese: "چینی",
      arabic: "عربی",
      persian: "فارسی",
    },
  },
  editor: {
    title: "نسخه ویرایش‌شده",
    unsaved: "تغییرات ذخیره نشده‌اند",
    saved: "پیش‌نویس ذخیره شده است",
    copied: "کپی شد",
    copy: "کپی",
    saveDraft: "ذخیره پیش‌نویس",
  },
  feedback: {
    draftSaved: "پیش‌نویس ذخیره شد.",
    approved: "پست تأیید شد و به صف پست‌های تأییدشده منتقل شد.",
    approveBeforePublishing: "پیش از انتشار، پست را تأیید کنید.",
    destinationRequired: "پیش از انتشار یک مقصد تلگرام را تنظیم و فعال کنید.",
    publishSuccess: "پست با موفقیت در مقصدهای انتخاب‌شده تلگرام منتشر شد.",
    publishFailed: "انتشار ناموفق بود. خطای مقصد را بررسی و دوباره تلاش کنید.",
    aiCurationError: "هوش مصنوعی نتوانست این پست را پردازش کند. تنظیمات ارائه‌دهنده را بررسی و دوباره تلاش کنید.",
    aiConnectionError: "ارتباط با ارائه‌دهنده هوش مصنوعی تنظیم‌شده برقرار نشد. دوباره تلاش کنید.",
    suggestionApplied: "پیشنهاد هوش مصنوعی اعمال شد. پس از آماده شدن، پست را ذخیره یا تأیید کنید.",
  },
  destinations: {
    selected_one: "{{formattedCount}} مقصد انتخاب شده است",
    selected_other: "{{formattedCount}} مقصد انتخاب شده است",
    noneEnabled: "هیچ مقصد تلگرامی فعالی وجود ندارد",
    publishingTo_one: "انتشار در {{formattedCount}} مقصد",
    publishingTo_other: "انتشار در {{formattedCount}} مقصد",
    configureToPublish: "برای انتشار یک مقصد تلگرام تنظیم کنید",
  },
  actions: {
    approve: "تأیید",
    publish: "انتشار",
    publishing: "در حال انتشار",
    archive: "بایگانی",
    restore: "بازیابی",
    sync: "همگام‌سازی منابع",
    syncing: "در حال همگام‌سازی",
  },
  search: {
    label: "جست‌وجوی پست یا کانال",
    placeholder: "جست‌وجوی پست یا کانال",
  },
  empty: {
    title: "هیچ پست «{{status}}» وجود ندارد",
    search: "پستی مطابق این جست‌وجو پیدا نشد. کانال یا عبارت دیگری را امتحان کنید.",
    default: "برای دریافت محتوای تازه تلگرام، کانال‌های منبع را همگام‌سازی کنید.",
  },
  queue: {
    title: "صف پست‌ها",
    count: "{{formattedCount}} · {{status}}",
    mediaPost: "پست رسانه‌ای",
  },
  mobile: {
    reviewPost: "بررسی پست",
    back: "بازگشت به فهرست پست‌ها",
    position: "{{current}} از {{total}}",
    steps: {
      review: "بررسی",
      approve: "تأیید",
      publish: "انتشار",
    },
    modeLabel: "حالت بررسی",
    modes: {
      original: "اصلی",
      edit: "ویرایش",
      preview: "پیش‌نمایش",
    },
  },
  accessibility: {
    originalPost: "پست اصلی",
    postStatus: "وضعیت پست",
    toolkit: "ابزارهای پردازش محتوا با هوش مصنوعی",
    curatedVersion: "نسخه ویرایش‌شده",
    postQueue: "صف پست‌ها",
    curatedEditor: "ویرایشگر پست",
    mobilePostList: "فهرست پست‌ها در موبایل",
    reviewPost: "بررسی پست",
  },
} as const;

export default inbox;
